// ============================================================
// src/api/ipApi.js  –  IP Whitelist & Access Log API calls
// ============================================================
// Backend: GET    /api/ip/whitelist
//          POST   /api/ip/whitelist
//          DELETE /api/ip/whitelist/:id
//          GET    /api/ip/access-log
//          GET    /api/ip/stats
//          POST   /api/ip/emergency
// ============================================================

import { apiFetch } from './apiConfig';

// GET all whitelisted IPs
export async function getWhitelist() {
  return apiFetch('/ip/whitelist');
}

// POST add an IP to whitelist
// data: { ip_value, ip_type, location_label }
export async function addIP(data) {
  return apiFetch('/ip/whitelist', {
    method: 'POST',
    body: data,
  });
}

// src/api/ipApi.js — add this function
export async function updateIP(id, data) {
  return apiFetch(`/ip/whitelist/${id}`, {
    method: 'PUT',
    body: data,
  });
}

// DELETE remove an IP from whitelist
export async function removeIP(id) {
  return apiFetch(`/ip/whitelist/${id}`, { method: 'DELETE' });
}

// GET access log entries
// filters: { type, limit }
export async function getAccessLog(filters = {}) {
  const params = new URLSearchParams();
  if (filters.type)  params.append('type',  filters.type);
  if (filters.limit) params.append('limit', filters.limit);
  return apiFetch(`/ip/access-log?${params.toString()}`);
}

// GET stats (totals for stat cards)
export async function getIPStats() {
  return apiFetch('/ip/stats');
}

// POST grant temporary emergency access
// data: { employee_id, ip_address, reason, hours }
export async function grantEmergency(data) {
  return apiFetch('/ip/emergency', {
    method: 'POST',
    body: data,
  });
}
